import * as React from "react";

import { cn } from "@/lib/utils";
import {
  resolveRunyiStatus,
  runyiStatusDotClasses,
  runyiStatusToneClasses,
} from "@/lib/status-indicator";

type StatusIndicatorProps = React.ComponentProps<"span"> & {
  status: string | null | undefined;
  label?: React.ReactNode;
  showDot?: boolean;
  compact?: boolean;
};

export function StatusIndicator({
  status,
  label,
  showDot = true,
  compact = false,
  className,
  ...props
}: StatusIndicatorProps) {
  const presentation = resolveRunyiStatus(status);
  const text = label ?? (presentation.label || "UNKNOWN");

  return (
    <span
      data-runyi-status="true"
      data-status-tone={presentation.tone}
      data-status-token={presentation.token || "UNKNOWN"}
      data-status-canonical-token={presentation.canonicalToken || "UNKNOWN"}
      data-status-source="explicit"
      aria-label={`Status: ${String(text)}`}
      className={cn(
        "inline-flex w-fit shrink-0 items-center justify-center rounded-full border font-semibold uppercase tracking-[0.08em]",
        compact ? "gap-1 px-2 py-0.5 text-[8px]" : "gap-1.5 px-2.5 py-1 text-[9px]",
        runyiStatusToneClasses[presentation.tone],
        className,
      )}
      {...props}
    >
      {showDot && <span aria-hidden="true" className={cn("size-1.5 shrink-0 rounded-full", runyiStatusDotClasses[presentation.tone])} />}
      <span>{text}</span>
    </span>
  );
}
